/* Floral Studio — open the header dropdown on hover.
   <details> only opens on click natively, so this toggles `open` on
   pointer devices. Click, keyboard and Escape keep working because
   Dawn's own details-disclosure is left untouched underneath. */
(function () {
  var FINE_POINTER = window.matchMedia('(hover: hover) and (pointer: fine)');
  var CLOSE_DELAY = 180; // grace period so a diagonal mouse path doesn't close it

  function wire(details) {
    if (details.dataset.fsHover === '1') return;
    details.dataset.fsHover = '1';

    var timer = null;

    function open() {
      if (!FINE_POINTER.matches) return;
      window.clearTimeout(timer);
      // Close any sibling that is open, so two panels never overlap
      var menu = details.closest('.header__inline-menu');
      if (menu) {
        menu.querySelectorAll('details[open]').forEach(function (d) {
          if (d !== details) d.removeAttribute('open');
        });
      }
      details.setAttribute('open', '');
    }

    function close() {
      if (!FINE_POINTER.matches) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        // Don't yank it shut while someone is tabbing through the links
        if (!details.contains(document.activeElement)) details.removeAttribute('open');
      }, CLOSE_DELAY);
    }

    /* A parent that points at a real page navigates on click instead of
       toggling. The panel is already open from hover by the time anyone
       clicks, so nothing is lost — and on a touch screen, where there is
       no hover, the tap must keep opening the panel or the children
       become unreachable. Hence the FINE_POINTER gate. */
    var summary = details.querySelector('summary');
    var href = summary && summary.getAttribute('data-fs-href');
    if (summary && href && href !== '/' && href !== '#' && href !== '') {
      summary.addEventListener('click', function (e) {
        if (!FINE_POINTER.matches) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        window.location.href = href;
      });
    }

    details.addEventListener('mouseenter', open);
    details.addEventListener('mouseleave', close);
    details.addEventListener('focusin', open);
    details.addEventListener('focusout', close);
  }

  function boot() {
    document.querySelectorAll('.header__inline-menu details').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // The theme editor re-renders the header section in place
  document.addEventListener('shopify:section:load', boot);
})();
